import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import GenericCost from './GenericCost';
import MaterialCost from './MaterialCost';
import OtherCost from './OtherCost';
import SubcontractCost from './SubcontractCost';
import GeneralSummary from './GeneralSummary';
import {
  COST_TYPE_LABOR,
  COST_TYPE_EQUIPMENT,
  COST_TYPE_MATERIAL,
  COST_TYPE_OTHER,
  COST_TYPE_SUBCONTRACT
} 
from '../common/redux/constantes';


function TabContainer(props) {
  return (
    <Typography component="div" >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    
  },
});

class Summary extends React.Component 
{
  state = {
    value: 0,
  };

  handleChange = (event, value) => 
  {
    this.setState({ value });
  };

  render() 
  {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <AppBar position="static"  style={{backgroundColor:"#00796B !important"}} color="#00796B" >
          <Tabs value={value} onChange={this.handleChange} style={{backgroundColor:"#f0f1f3"}} indicatorColor="primary" >
            <Tab label="Labor" />
            <Tab label="Equipment"/>
            <Tab label="Material"/>
            <Tab label="Subcontract"/>
            <Tab label="Other"/>
            <Tab label="Summary"/>
          </Tabs>
        </AppBar>
        {(value === 0) && <TabContainer><GenericCost ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project} type={COST_TYPE_LABOR}/></TabContainer>}
        {(value === 1) && <TabContainer><GenericCost  ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project} type={COST_TYPE_EQUIPMENT}/></TabContainer>}
        {(value === 2) && <TabContainer><MaterialCost  ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project} type={COST_TYPE_MATERIAL}/></TabContainer>}
        {(value === 3) && <TabContainer><SubcontractCost  ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project} type={COST_TYPE_SUBCONTRACT}/></TabContainer>}
        {(value === 4) && <TabContainer><OtherCost  ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project} type={COST_TYPE_OTHER}/></TabContainer>}
        {(value === 5) && <TabContainer><GeneralSummary  ca_name={this.props.ca_name} ca={this.props.ca} project={this.props.project}/></TabContainer>}
      </div>
    );
  }
}

Summary.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Summary);



// WEBPACK FOOTER //
// ./src/features/summary/Summary.js